import {
    Component,
    effect,
    inject,
    input,
    Signal,
    ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseLoadingService } from '@fuse/services/loading';

@Component({
    selector: 'fuse-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'fuseLoadingBar',
    imports: [MatProgressBarModule],
})
export class FuseLoadingBarComponent {
    private readonly fuseLoadingService = inject(FuseLoadingService);

    public readonly autoMode = input<boolean>(true);

    protected readonly mode: Signal<'determinate' | 'indeterminate'> = this.fuseLoadingService.modeInput;
    protected readonly progress: Signal<number | null> = this.fuseLoadingService.progressInput;
    protected readonly show: Signal<boolean> = this.fuseLoadingService.visibleInput;

    constructor() {
        effect(() => {
            this.fuseLoadingService.setAutoMode(this.autoMode());
        });
    }
}
